"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HalController = void 0;
const index_1 = __importDefault(require("./index"));
class HalController {
    constructor(endpoint, query = {}, key) {
        this._endpoint = endpoint;
        this._query = query;
        this._key = key;
    }
    get data() {
        if (!this._origin) {
            throw new Error("Fetch your hal resources first!");
        }
        const _a = this._origin, { _links, _embedded } = _a, data = __rest(_a, ["_links", "_embedded"]);
        return data;
    }
    get links() {
        if (!this._origin) {
            throw new Error("Fetch your hal resources first!");
        }
        return this._origin._links || {};
    }
    get embedded() {
        if (!this._origin) {
            throw new Error("Fetch your hal resources first!");
        }
        if (!this._embedded) {
            const halEmbedded = this._origin._embedded || {};
            const embedded = {};
            for (const [key, value] of Object.entries(halEmbedded)) {
                embedded[key] = Array.isArray(value)
                    ? value.map((val) => HalController.fromObject(val))
                    : HalController.fromObject(value);
            }
            this._embedded = embedded;
        }
        return this._embedded;
    }
    static fromObject(halObject) {
        var _a, _b;
        const controller = new HalController(((_b = (_a = halObject._links) === null || _a === void 0 ? void 0 : _a.self) === null || _b === void 0 ? void 0 : _b.href) || "");
        controller._origin = halObject;
        return controller;
    }
    toObject() {
        return this._origin || {};
    }
    follow(name, query = {}, init = {}) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            if (!this._origin) {
                yield this.get();
            }
            const link = (_b = (_a = this._origin) === null || _a === void 0 ? void 0 : _a._links) === null || _b === void 0 ? void 0 : _b[name];
            if (!link) {
                throw new Error(`Invalid link name "${name}" on ${this._endpoint}`);
            }
            const controller = new HalController(Array.isArray(link) ? link[0].href : link.href, query, name);
            yield controller.get(init);
            return controller;
        });
    }
    get(init = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this._originPromise) {
                this._originPromise = index_1.default
                    .get(this._endpoint, this._query, init, this._key)
                    .then((origin) => this._origin = origin);
            }
            yield this._originPromise;
        });
    }
}
exports.HalController = HalController;
